import { DefaultTheme } from "styled-components";

import { SVG_ICON_SIZE } from "uikit/constants";

import { Breakpoints } from "../types";
import colors from "./colors";

declare module "styled-components" {
  type Theme = typeof theme;
  export interface DefaultTheme {
    defaultRadius: string;

    colors: typeof colors;

    fontFamily: {
      default: string;
    };

    fontWeight: {
      /** 800*/
      extraBold: number;
      /** 700*/
      bold: number;
      /** 600*/
      semiBold: number;
      /** 500*/
      medium: number;
      /** 400*/
      regular: number;
    };

    fontStyle: {
      normal: string;
      italic: string;
      oblique: string;
    };

    size: {
      /** "40px" */
      h40: string;
      /** "32px" */
      h32: string;
      /** "24px" */
      h24: string;
      /** "20px" */
      t20: string;
      /** "18px" */
      t18: string;
      /** "16px" */
      t16: string;
      /** "14px" */
      t14: string;
      /** "12px" */
      t12: string;
      /** "10px" */
      t10: string;

      /** "24px" (Deprecated) */
      title: string;

      /** "26px" (Deprecated) */
      titleMedium: string;

      /** "28px" (Deprecated) */
      titleSemiLarge: string;

      /** "32px" (Deprecated) */
      titleSemiLargeAlt: string;

      /** "36px" (Deprecated) */
      titleLarge: string;

      /** "40px" (Deprecated) */
      titleLarger: string;

      /** "18px" (Deprecated) */
      subtitle: string;

      /** "20px" (Deprecated) */
      subtitleLarge: string;

      /** "22px" (Deprecated) */
      subtitleLarger: string;

      /** "16px" (Deprecated) */
      body1: string;

      /** "14px" (Deprecated) */
      body2: string;

      /** "12px" (Deprecated) */
      caption: string;

      /** "10px" (Deprecated) */
      small: string;
    };
    lineHeight: {
      /** "140%" */
      lh140: string;
      /** "130%" */
      lh130: string;
    };

    padding: {
      /** "4px" */
      p4: string;
      /** "8px" */
      p8: string;
      /** "10px" */
      p10: string;
      /** "12px" */
      p12: string;
      /** "16px" */
      p16: string;
      /** "20px" */
      p20: string;
      /** "22px" */
      p22: string;
      /** "24px" */
      p24: string;
      /** "32px" */
      p32: string;
      /** "40px" */
      p40: string;
    };

    margin: {
      /** "4px" */
      m4: string;
      /** "8px" */
      m8: string;
      /** "10px" */
      m10: string;
      /** "12px" */
      m12: string;
      /** "16px" */
      m16: string;
      /** "20px" */
      m20: string;
      /** "22px" */
      m22: string;
      /** "24px" */
      m24: string;
      /** "32px" */
      m32: string;
      /** "40px" */
      m40: string;
    };

    zIndex: {
      modal: number;
      slidePane: number;
      loader: number;
    };
    iconSize: typeof SVG_ICON_SIZE;
    breakpoints: Breakpoints;

    // FIXME::: Deprecated
    contentPadding: Breakpoints;
  }
}

const theme: DefaultTheme = {
  defaultRadius: "24px",
  colors,

  fontFamily: {
    default: "Plus Jakarta Sans",
  },

  fontWeight: {
    extraBold: 800,
    bold: 700,
    semiBold: 600,
    medium: 500,
    regular: 400,
  },

  fontStyle: {
    normal: "normal",
    italic: "italic",
    oblique: "oblique",
  },

  size: {
    h40: "40px",
    h32: "32px",
    h24: "24px",
    t20: "20px",
    t18: "18px",
    t16: "16px",
    t14: "14px",
    t12: "12px",
    t10: "10px",

    title: "24px",
    titleMedium: "26px",
    titleSemiLarge: "28px",
    titleSemiLargeAlt: "32px",
    titleLarge: "36px",
    titleLarger: "40px",
    subtitle: "18px",
    subtitleLarge: "20px",
    subtitleLarger: "22px",
    body1: "16px",
    body2: "14px",
    caption: "12px",
    small: "10px",
  },

  lineHeight: {
    lh140: "140%",
    lh130: "130%",
  },

  padding: {
    p4: "4px",
    p8: "8px",
    p10: "10px",
    p12: "12px",
    p16: "16px",
    p20: "20px",
    p22: "22px",
    p24: "24px",
    p32: "32px",
    p40: "40px",
  },

  margin: {
    m4: "4px",
    m8: "8px",
    m10: "10px",
    m12: "12px",
    m16: "16px",
    m20: "20px",
    m22: "22px",
    m24: "24px",
    m32: "32px",
    m40: "40px",
  },

  zIndex: {
    loader: 100000,
    modal: 10000,
    slidePane: 100,
  },

  breakpoints: {
    xs: 0,
    sm: 360,
    md: 768,
    lg: 1024,
    xlm: 1280,
    xl: 1440,
    xxl: 1600,
  },
  iconSize: SVG_ICON_SIZE,

  // FIXME::: Deprecated
  contentPadding: {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 40,
    xlm: 20,
    xl: 80,
    xxl: 80,
  },
};

export { theme };
